import { AppShell } from './ui/AppShell';

export default function App() {
  return <AppShell />;
}
